import styled from "styled-components"

import {H4, H6, Label} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"

interface Props {
  isSelected: boolean
}
interface StyledCardProps extends Props {
  hideSelector: boolean
}

export const GradientBody = styled(Label)`
  ${({theme}) => `
  background: linear-gradient(88.64deg, ${theme.colors.primary1} 0%, ${theme.colors.secondary1} 100%);
  border-radius: 4px;
  color: ${theme.colors.greys.white};
`}
`

export const Recommended = styled(GradientBody)`
  position: absolute;
  top: -36px;
  right: 45px;
`

export const StyledCard = styled(Card)<StyledCardProps>`
  ${({hideSelector}) => !hideSelector && "cursor: pointer;"}
  ${({isSelected}) => !isSelected && "border: 1px solid white;"}
  position: relative;
  min-width: 205px;
  flex-shrink: 0;
`

export const Height = styled.div`
  height: 45px;
`

export const OuterCircle = styled.div<Props>`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  ${({theme, isSelected}) =>
    isSelected
      ? `
    background: ${theme.colors.greys.white};
    border: 1px solid ${theme.colors.primary2};
    `
      : `
    background: ${theme.colors.primary2};
    border: 1px solid white;
    `}
`

export const InnerCircle = styled.div<Props>`
  height: 15px;
  width: 15px;
  border-radius: 50%;
  display: inline-block;
  position: relative;
  top: 3.5px;
  left: 4px;
  ${({theme, isSelected}) => (isSelected ? `background: ${theme.colors.greys.white};` : `background: ${theme.colors.primary2};`)}
`
